import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button } from "@domestika-dev/prudencio/dist/atoms/Buttons";
import { Flex } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import When from "../../../../common/When";

export const LiveSetupFooter = ({
  enableNavigation,
  onNextStep,
  nextButtonText,
  nextButtonDisabled,
}) => {
  return (
    <When condition={enableNavigation}>
      {() => (
        <Flex
          position="absolute"
          bottom={0}
          left={0}
          width="100%"
          justifyContent="flex-end"
          backgroundColor="coco"
          paddingRight={["16px", "40px", "80px"]}
          paddingBottom={["16px", "40px", "40px"]}
          style={{ zIndex: 9999 }}
        >
          <Button size="medium" action={onNextStep} disabled={nextButtonDisabled}>
            <Text size={["tiny", "tiny", "small"]} fontWeight="medium" color="coco">
              <FormattedMessage id={nextButtonText} />
            </Text>
          </Button>
        </Flex>
      )}
    </When>
  );
};

LiveSetupFooter.propTypes = {
  enableNavigation: PropTypes.bool,
  nextButtonDisabled: PropTypes.bool,
  nextButtonText: PropTypes.string.isRequired,
  onNextStep: PropTypes.func.isRequired,
};

LiveSetupFooter.defaultProps = {
  enableNavigation: false,
  nextButtonDisabled: false,
};

export default LiveSetupFooter;
